$(() => {
    const priceTags = $('.product__form-footer .product__form-price');

    $('input.addition-input').each((i, e) => {
        if (e.checked) {
            const priceTag = $(e).parents('.product-addition').find('.main-price-b');
            const additionPrice = Number(priceTag.attr('data-value'));

            priceTags.each(function (index) {
                const price = Number($(this).text().replace(/\s/g, ''));
                $(this).text((price + additionPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
            });
        }
    });


    $('input.addition-input').on('change', function () {
        const priceTag = $(this).parents('.product-addition').find('.main-price-b');
        const additionPrice = Number(priceTag.attr('data-value'));
        const add = $(this).is(':checked');

        priceTags.each(function (index) {
            const price = Number($(this).text().replace(/\s/g, ''));
            $(this).text((add ? price + additionPrice : price - additionPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
        });
    });
})
